import { Box, CircularProgress } from "@material-ui/core";
import { useEffect } from "react";
import { participantPortalUrl } from "../../../common/config";

export const ParticipantStripePage = () => {
  useEffect(() => {
    window.location.href = participantPortalUrl;
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100vw"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};
